// INDENTED   : 0  => [1, 2, 3, 20, 21, 25, 39]
// ASSIGNED   : 4  => [16, 22, 24]
// ARRIVED    : 5  => [17, 18]
// DISPATCHED : 6  => []
// DELIVERED  : 7  => [23]
// CANCELLED  : 8  => []
// REQUESTED  : 25 => []

const indentStatusList = [
  {
    id: 0,
    name: 'indented',
    label: 'Indented',
    color: 'status-purple',
    tlabel: 'INDENT_INDENTED_STATUS',
    order: 1,
  },
  {
    id: 1,
    name: 'truck_change_requested',
    label: 'Truck Change Requested',
    color: 'status-purple',
    tlabel: 'INDENT_TRUCK_CHANGE_REQUESTED_STATUS',
    order: 2,
  },
  {
    id: 2,
    name: 'indent_rejected',
    label: 'Rejected',
    newLabel: 'Transporter Rejected',
    color: 'status-purple',
    tlabel: 'INDENT_REJECTED_STATUS',
    order: 3,
  },
  {
    id: 998,
    name: 'freight_change_requested',
    label: 'Freight Change Requested',
    tlabel: 'INDENT_FREIGHT_CHANGE_REQUESTED_STATUS',
  },
  {
    id: 3,
    name: 'indent_accepted',
    label: 'Accepted',
    color: 'status-purple',
    tlabel: 'INDENT_ACCEPTED_STATUS',
    order: 4,
  },
  {
    id: 4,
    name: 'truck_assigned',
    label: 'Assigned',
    color: 'status-pink',
    tlabel: 'INDENT_ASSIGNED_STATUS',
    order: 7,
  },
  {
    id: 5,
    name: 'truck_arrived',
    label: 'Arrived',
    color: 'status-teal',
    tlabel: 'INDENT_ARRIVED_STATUS',
    order: 11,
  },
  {
    id: 6,
    name: 'dispatched',
    label: 'Dispatched',
    color: 'status-blue',
    tlabel: 'INDENT_DISPATCHED_STATUS',
    order: 14,
  },
  {
    id: 7,
    name: 'delivered',
    label: 'Delivered',
    color: 'status-green',
    tlabel: 'INDENT_DELIVERED_STATUS',
    order: 16,
  },
  {
    id: 8,
    name: 'cancelled',
    label: 'Cancelled',
    color: 'status-red',
    tlabel: 'INDENT_CANCELLED_STATUS',
    order: 17,
  },
  {
    id: 16,
    name: 'truck_rejected',
    label: 'Rejected',
    newLabel: 'Truck Rejected',
    color: 'status-pink',
    tlabel: 'INDENT_REJECTED_STATUS',
    order: 8,
  },
  {
    id: 17,
    name: 'loading_started',
    label: 'Loading Started',
    color: 'status-teal',
    tlabel: 'INDENT_LOADING_STARTED_STATUS',
    order: 12,
  },
  {
    id: 18,
    name: 'loading_ended',
    label: 'Loading Ended',
    color: 'status-teal',
    tlabel: 'INDENT_LOADING_ENDED_STATUS',
    order: 13,
  },
  {
    id: 20,
    name: 'indent_assign_due',
    label: 'Assignment Due',
    color: 'status-purple',
    tlabel: 'INDENT_ASSIGNMENT_DUE_STATUS',
    order: 5,
  },
  {
    id: 21,
    name: 'indent_accept_due',
    label: 'Acceptance Due',
    color: 'status-purple',
    tlabel: 'INDENT_ACCEPTANCE_DUE_STATUS',
    order: 6,
  },
  {
    id: 22,
    name: 'indent_arrived_due',
    label: 'Arrival Due',
    color: 'status-pink',
    tlabel: 'INDENT_ARRIVAL_DUE_STATUS',
    order: 9,
  },
  {
    id: 23,
    name: 'delivery_pending',
    label: 'Del Pending',
    color: 'status-green',
    tlabel: 'INDENT_DEL_PENDING_STATUS',
    order: 15,
  },
  {
    id: 24,
    name: 'reported',
    label: 'Reported',
    color: 'status-pink',
    tlabel: 'INDENT_REPORTED_STATUS',
    order: 10,
  },
  {
    id: 25,
    name: 'requested',
    label: 'Requested',
    tlabel: 'INDENT_REQUESTED_STATUS',
    color: 'status-orange',
  },
  {
    id: 26,
    name: 'container_picked',
    label: 'CTR Picked',
    color: 'status-teal',
    tlabel: 'INDENT_CTR_PICKED_STATUS',
    order: 0,
  },
  {
    id: 27,
    name: 'drafted',
    label: 'Draft',
    tlabel: 'INDENT_DRAFT_STATUS',
    color: 'status-grey',
    order: 1,
  },
  {
    id: 39,
    name: 'pending',
    label: 'Pending',
    tlabel: 'PENDING',
    color: 'status-grey',
    order: 28,
  },
];
const newStatus = {
  INDENT_REPORTED_AT_DESTINATION: 11,
  INDENT_UNLOADING_STARTED:12
};

const statusIdDictionary = indentStatusList.reduce((acc, status) => {
  acc[status.name] = status.id;
  return acc;
}, {});

const statusNameDictionary = indentStatusList.reduce((acc, status) => {
  acc[status.id] = status.name;
  return acc;
}, {});

const swimlaneGroupStatusIdDictionary = {
  'in-planning': [0, 1, 2, 3, 4, 20, 21, 25, 39, 16, 22, 24, 27, 998],
  'in-loading': [5, 17, 18],
  'in-transit': [6],
  'in-delivery-pending': [23],
  'completed': [8, 7],
};

const swimlaneGroupStatusNameDictionary = Object.keys(swimlaneGroupStatusIdDictionary).reduce((acc, key) => {
  acc[key] = swimlaneGroupStatusIdDictionary[key].map(statusId => statusNameDictionary[statusId]);
  return acc;
}, {});

const indentStatusMapping = {
  0: [1, 2, 3, 20, 21, 25, 39, 998],
  4: [16, 22, 24],
  5: [17, 18],
  6: [],
  7: [23],
  8: [],
  25: [],
  26: [],
  27: [],
  39: [],
};

const sequenceNumberIndentStatusMap = {
  0: [27],
  1: [0, 1, 2, 3, 20, 21, 25, 998],
  2: [26],
  3: [4, 16, 22, 24],
  4: [5, 17, 18],
  5: [6],
  6: [8],
  7: [7, 23],
  8: [],
};

const deliveryType = {
  FTL: 1,
  PTL: 2,
};
const deliveryTypes = {
  FTL: 'FTL',
  PTL: 'PTL',
};

const orderType = {
  CONTRACT: 0,
  OPEN: 1,
  NO_FREIGHT: 2,
  MARKET: 3,
};

const orderTypes = [
  {
    name: 'CONTRACT',
    id: 0,
    view_permission: 'view_contract_indent',
    create_permission: 'create_contract_indent',
    update_permission: 'update_contract_indent',
    label: 'Contract',
    iconName: 'status_contract',
  },
  {
    name: 'OPEN',
    id: 1,
    view_permission: 'view_open_indent',
    create_permission: 'create_open_indent',
    update_permission: 'update_open_indent',
    label: 'Open',
    iconName: 'status_open',
  },
  {
    name: 'NO FREIGHT',
    id: 2,
    view_permission: 'view_no_freight_indent',
    create_permission: 'create_no_freight_indent',
    update_permission: 'update_no_freight_indent',
    label: 'No Freight',
    iconName: 'status_nofreight',
  },
  {
    name: 'MARKET',
    id: 3,
    view_permission: 'view_market_indent',
    create_permission: 'create_market_indent',
    update_permission: 'update_market_indent',
    label: 'Market',
    iconName: 'status_market',
  },
];

const filterType = {
  CLEAN: 1,
  NON_CLEAN: 2,
};

const movement = {
  SECONDARY: 1,
  PRIMARY: 2,
};

const movementTypes = {
  SECONDARY: 'Secondary',
  PRIMARY: 'Primary',
};

const truckUtilization = {
  NONE: 0,
  WEIGHT: 1,
  VOLUME: 2,
  WEIGHTANDVOLUME: 3,
  WEIGHTORVOLUME: 4,
};

const indentMessage = {
  AUTO_INDENT_CANCEL: 'Indent auto-cancelled by System!',
  NO_BIDS_ACCEPTED: 'No Quotes given by transporters',
  SHIPPER_REJECT_ALL: 'Shipper rejected all transporters',
  NO_ACTION_PERFORMED: 'No action performed on the indent',
};

const bulkUploadList = {
  bulkUpload: 'Indent Bulk Upload',
  podBulkUpload: 'GRN Bulk Upload',
  consigneePodFileUpload: 'POD Bulk Upload',
  materialBulkUpload: 'Material Bulk Upload',
};

const GrnUploadMssg = {
  ERR_INDENT_OR_SHIP_NUM_REQ: 'Either indent number or shipment number is required',
  ERR_SHIP_TO_REQ: 'ship to is required',
  ERR_SOLD_TO_REQ: 'sold to is required',
  ERR_DEL_NUM_REQ: 'delivery number is required',
  ERR_MAT_INVOICE_NUM_REQ: 'material invoice number is required',
  ERR_MAT_CODE_REQ: 'material code is required',
  ERR_MRP_REQ: 'mrp is required',
  ERR_NO_OF_SHORTAGE_REQ: 'no of shortage is required',
  ERR_SHORTAGE_UNIT_REQ: 'shortage unit is required',
  ERR_NO_OF_DAMAGE_IS_REQ: 'no of damage is required',
  ERR_DAMAGE_UNIT_REQ: 'damage unit is is required',
  ERR_NO_OF_CARTON_DAMAGE_REQ: 'no of carton damage is required',
  ERR_CARTON_DAMAGE_UNIT_REQ: 'carton damage unit is required',
};

const truckAssignMsg = {
  ERR_MOBILE_NUMBER: 'Invalid mobile number',
  ERR_DATE_FORMAT: 'Invalid date format',
};

const chatSettingErrorMsg = {
  ERR_INVALID_INPUT_TYPE: 'Invalid input type',
};

const cancellationType = {
  AUTO_CANCEL: 4,
};

const orderTypePermissions = {
  CONTRACT: {
    create: 'create_contract_indent',
    update: 'update_contract_indent',
    view: 'view_contract_indent',
  },
  OPEN: {
    create: 'create_open_indent',
    update: 'update_open_indent',
    view: 'view_open_indent',
  },
  NO_FREIGHT: {
    create: 'create_no_freight_indent',
    update: 'update_no_freight_indent',
    view: 'view_no_freight_indent',
  },
  MARKET: {
    create: 'create_market_indent',
    update: 'update_market_indent',
    view: 'view_market_indent',
  },
};

const BidType = {
  RFQ: 1,
  MARKET: 2,
};

const BlacklistStatus = {
  BLACKLIST: 1,
  UNBLACKLIST: 2,
};

const deliveryPendingReasonsMapping = {
  DEFAULT: 0,
  MATERIAL_LIST_NA: 1,
  MATERIAL_INVOICE_NA: 2,
  EPOD_NA: 3,
  OTP_VERIFICATION: 4,
  BASE_FREIGHT_APPROVAL_PENDING: 5,
  GRN_APPROVAL_PENDING: 6
};

const RfqCommentType = {
  accept: 'ACCEPT :',
  reject: 'REJECT ALL :',
};
const BREACHED_TEXT = 'Sla breached';
const ACCEPTANCE_BREACHED_TEXT = 'Acceptance sla breached';

const sourceAndDestinationType = {
  DEPOT: 1,
  CONSIGNEE: 2,
  VENDOR_DEPOT: 3,
  PORT: 4,
  NO_MASTER_ENTITY: 5,
  HUB: 6,
};

const materialErrorType = {
  MATERIAL_NOT_FOUND: 1,
  SHIP_TO_NOT_FOUND: 2,
  SOLD_TO_NOT_FOUND: 3,
  GATE_ID_NOT_FOUND: 4,
  WEIGHT_VOLUME_MISSING: 5,
  DELIVERY_DUPLICATE: 6,
  WEIGHT_VOLUME__UNIT_MISSING_IN_SYSTEM: 7,
  QUANTITY_MISSING: 8,
  WEIGHT_MISSING: 9,
  VOLUME_MISSING: 10,
  INVALID_DATE_FORMAT: 11,
  WEIGHT_NOT_AVAILABLE_IN_MASTER: 12,
  VOLUME_NOT_AVAILABLE_IN_MASTER: 13,
  PACKAGE_NOT_FOUND: 14,
  PACKAGE_WEIGHT_NOT_AVAILABLE_IN_MASTER: 15,
  PACKAGE_VOLUME_NOT_AVAILABLE_IN_MASTER: 16,
  INVALID_EWAY_BILL_DATE_FORMAT: 17,
};

const materialReason = {
  1: 'Material not found',
  2: 'Ship to not found',
  3: 'Sold to not found',
  4: 'Gate not found',
  5: 'Weight / Volume missing',
  6: 'Duplicate Deliveries',
  7: 'Weight / Volume unit not available',
  8: 'Quantity missing',
  9: 'Weight missing / invalid',
  10: 'volume  missing / invalid',
  11: 'Invalid Date Format',
  12: 'Weight is missing / Weight is not available in master',
  13: 'Volume is missing / Volume is not available in master',
  14: 'Package not found',
  15: 'Package Weight is missing / Weight is not available in master',
  16: 'Package Volume is missing / Volume is not available in master',
  17: 'Invalid Eway Bill Date Format',
};

const LorryReceiptGenerationCategory = {
  CONSIGNEE_WISE: 1,
  GATE_WISE: 2,
  DIVISION_WISE: 3,
  LEGAL_ENTITY_WISE: 4,
  MATERIAL_WISE: 5,
};

const indentCategory = {
  ROUND_TRIP: 1,
  MULTI_LEG: 2,
  PACKING: 3,
};

const RfqAcceptLogLimit = 3;

const materialInvoiceOtpStatus = {
  GENERATED: 1,
  APPROVED: 2,
};

const epodDeleteDataReason = {
  GATE_DELETED: 'GAT-MAT-DELETED',
  GATE_AND_DESTINATION_DELETED: 'GAT-DEST-MAT-DELETED',
  DESTINATION_DELETED: 'DEST-MAT-DELETED',
  MATERIAL_DELETED: 'MAT-DELETED',
  NA: 'NA',
};
const languageMapping = [
  {
    id: 'en',
    name: 'ENGLISH',
  },
  {
    id: 'hi',
    name: 'HINDI',
  },
];

const materialTypes = {
  STD_MATERIAL: 'STD_MATERIAL',
  KIT_MATERIAL: 'KIT_MATERIAL',
};

const eventTypes = {
  TRUCK_IN: 'TRUCK_IN',
  TRUCK_OUT: 'TRUCK_OUT',
  LR_ATTACH: 'LR_ATTACH',
  LR_DELETE: 'LR_DELETE',
  GRN_EVENT: 'GRN_EVENT',
  SHIPPER_GRN_EVENT: 'SHIPPER_GRN_EVENT',
  APPROVE_OTP: 'APPROVE_OTP',
  CONSIGNEE_APPROVE_OTP: 'CONSIGNEE_APPROVE_OTP',
  MARK_DELIVERY: 'MARK_DELIVERY',
  INDENT_CREATION: 'INDENT_CREATION',
  INDENT_UPDATION: 'INDENT_UPDATION',
  INDENT_CANCELLATION: 'INDENT_CANCELLATION',
  PRE_PLAN_MATERIALS: 'PRE_PLAN_MATERIALS',
  ADVANCE_SHIPMENT_NOTICE: 'ADVANCE_SHIPMENT_NOTICE',
  GRN_INTERFACE: 'GRN_INTERFACE',
  REACH_AND_RELEASE: 'REACH_AND_RELEASE',
  PTL_GROUP_TRUCK_ASSIGN: 'PTL_GROUP_TRUCK_ASSIGN',
  MATERIAL_INVOICE: 'MATERIAL_INVOICE',
  APPROVE_OTP_SHIPPER: 'APPROVE_OTP_SHIPPER',
  ERP_MATERIAL_INVOICE: 'ERP_MATERIAL_INVOICE',
  CHARGEABLE_WEIGHT: 'CHARGEABLE_WEIGHT',
  INDENT_DELIVERED: 'INDENT_DELIVERED',
  TRUCK_ASSIGN: 'TRUCK_ASSIGN',
  LR_NUMBER: 'LR_NUMBER',
  ERP_LR_UPDATE: 'ERP_LR_UPDATE',
  AUTO_LR_UPDATE: 'AUTO_LR_UPDATE',
  COURIER_BOOKING_UPDATE: 'COURIER_BOOKING_UPDATE'
};

const chainEvents = {
  MODIFIED_PICKLIST: 'MODIFIED_PICKLIST',
  SPLIT_MODIFIED_PICKLIST: 'SPLIT_MODIFIED_PICKLIST',
  ZPOD: 'ZPOD',
  MODIFIED_PICKLIST_POST_TRUCK_IN: 'MODIFIED_PICKLIST_POST_TRUCK_IN',
  UPDATE_SHIPMENT_NUMBER: 'UPDATE_SHIPMENT_NUMBER',
  PRE_PLAN_UPDATE_NOTIFICATION_DB: 'PRE_PLAN_UPDATE_NOTIFICATION_DB',
  MATERIAL_UPLOAD_PRE_EVENT: 'MATERIAL_UPLOAD_PRE_EVENT',
  OPTIMA_UPDATE_EXCEPTION_DB: 'OPTIMA_UPDATE_EXCEPTION_DB',
  UPDATE_INDENT_DISTRIBUTION_COUNT: 'UPDATE_INDENT_DISTRIBUTION_COUNT',
  MATERIAL_DISPATCH_THROUGHPUT: 'MATERIAL_DISPATCH_THROUGHPUT',
  TRIGGER_COURIER_BOOKING: 'TRIGGER_COURIER_BOOKING',
  SHIPMENT_STATUS_UPDATE: 'SHIPMENT_STATUS_UPDATE',
};

const findIndentByOnMaterialProces = {
  DELIVERY_NUMBER: 1,
  INDENT_NUMBER: 2,
};

const inverseFreighUnit = {
  'per trip': 1,
  'per ton': 2,
  'per kg': 3,
  'per cft': 4,
  'per package': 5,
  'per case': 6,
  'per box': 7,
  'per km': 8,
};

const indentFCMActions = {
  INDENT_STATUS_UPDATE: 'INDENT_STATUS_UPDATE',
};

const indentFCMStatusChanges = {
  TRUCKIN: 'TRUCK_IN',
};

const fcmNotificationTypes = {
  TRUCK_IN: 'truck_in',
};

const tripStatus = {
  TRIP_CREATED: 'STARTED',
  GEOFENCE_ENTRY_AT_SOURCE: 'GEOFENCE_ENTRY_AT_SOURCE',
  GEOFENCE_EXIT_AT_SOURCE: 'GEOFENCE_EXIT_AT_SOURCE',
  GEOFENCE_ENTRY_AT_DESTINATION: 'GEOFENCE_ENTRY_AT_DESTINATION',
  GEOFENCE_EXIT_AT_DESTINATION: 'GEOFENCE_EXIT_AT_DESTINATION',
  TRIP_COMPLETE: 'TRIP_COMPLETE',
};

const tripType = {
  GPS: 'GPS',
  SIM: 'SIM',
  APP: 'APP',
  HYPERTRACK: 'HYPERTRACK',
};
// For consignment bulk upload in transporter app
const consignmentBulkHeader = {
  'INDENT NO*': 'indent_no',
  'DESTINATION REFERENCE ID*': 'destination_reference_id',
  'LR NUMBER*': 'consignment_number',
};

// Minimum number of transporters to be selected to enable Request for RFQ
const minTransportersCountForRFQ = 2;

const integrationApiHistoryType = {
  FP_POSTING: 'FP_POSTING',
  MP_POSTING: 'MP_POSTING',
};

const ptlGroupActions = {
  REPORT_AT_DEPOT: 'report_at_depot',
  START_LOAD: 'start_load',
  END_LOAD: 'end_load',
  TRUCK_IN: 'truck_in',
  TRUCK_OUT: 'truck_out',
  INSPECTION: 'inspection',
  REACHED_LOADING_POINT: 'reached_loading_point',
  UPDATE_TRUCK: 'update_truck',
  ASSIGN_TRUCK_TRANSPORTER: 'assign_truck_transporter',
  REJECT_INDENT_TRANSPORTER: 'reject_indent_transporter',
};

const indentDistanceUploadChunkSize = 2000;
const packageUnitTypes = {
  CORRUGATED_BOXES: 'Corrugated Boxes',
  CARTONS: 'Cartons',
  STORAGE_BINS: 'Storage Bins',
  TROLLEYS: 'Trolleys',
};

const exceptionType = {
  INDENTS: '1',
  DELIVERIES: '2',
  DIRECT_DISPATCH: '3',
  OPTIMA: '4',
};

const exceptionDeviationType = {
  MATERIAL_QUANTITY: 'Material Quantity',
  MATERIAL_UNIT: 'Material Quantity Unit',
  SHIPMENT_NUM: 'Shipment Number',
  VEHICLE_ASSIGNMENT: 'Vehicle Assignment',
  TRUCK_IN: 'Truck In',
  MATERIAL_INVOICE: 'Material Invoice',
  TRUCK_OUT: 'Truck Out',
  REACH: 'Destination Reach',
};

const indentSourceMapping = {
  1: 'REGULAR',
  2: 'OPTIMA',
  3: 'BULK',
  4: 'INTEGRATION',
  5: 'OPTIMA_FOR_PTL',
  6: 'DIRECT_DISPATCH',
  7: 'OPTIMA_DIRECT_DISPATCH',
  8: 'EXIM',
  9: 'OPTIMA_MULTILEG',
  10: 'ERP',
};

const UnloadingStartEndErrorMsg = {
  INDENT_UNLOADING_END_BTWN_UNLOADING_START_RELEASE: 'Unloading end time should be between unloading start and release time',
  INDENT_UNLOADING_START_BTWN_REPORTED_UNLOADING_END: 'Unloading start time should be between reported and unloading end time',
  INDENT_UNLOADING_START_BTWN_REPORTED_CURRENT_TIME: 'Unloading start time should be between reported and current time',
  INDENT_UNLOADING_END_BTWN_UNLOADING_START_CURRENT_TIME: 'Unloading end time should be between unloading start and current time',

};

const sealNumberUpdatedAt = {
  SOURCE: 'source',
  DESTINATION: 'destination',
};

const autoSwitchBasedOn = {
  CHEAPEST: 'cheapest',
  TSD_MATRIX_PERCENTAGE: 'tsd_matrix_percentage',
  AVAILABILITY: 'availability',
  SERVICEABILITY: 'serviceability',
};

const indentCreateUpdateErrors = {
  ERR_DUPLICATE_SHIPMENT_NUMBER: 'Entered shipment number already exists',
  ERR_ACCEPTANCE_SLA_NOT_FOUND: 'Acceptance sla contains only default values or no values',
  ERR_EXTEND_SLA_BY: 'SLA grace extension not allowed',
  ERR_ROUTE_DOES_NOT_EXIST: 'Route does not exist for given source, destination combination',
  ERR_CHECK_ROUTE_MASTER_FEATURE_MISSING: 'check_route_master feature is disabled',
};

const materialAction = {
  APPEND: 'append',
  REPLACE: 'replace',
};

const materialActionErrorMessage = {
  ERROR_MESSAGE: 'action_type / action_by / clear is required',
  PATH: 'Material Actions',
};

const lastMileEntityTypes = {
  PICKUP: 1,
  DROPOFF: 2,
};

module.exports = {
  indentStatusList,
  indentStatusMapping,
  deliveryType,
  orderType,
  orderTypes,
  filterType,
  movementTypes,
  movement,
  GrnUploadMssg,
  truckUtilization,
  deliveryTypes,
  indentMessage,
  orderTypePermissions,
  bulkUploadList,
  BidType,
  BlacklistStatus,
  cancellationType,
  deliveryPendingReasonsMapping,
  RfqCommentType,
  sourceAndDestinationType,
  materialErrorType,
  materialReason,
  RfqAcceptLogLimit,
  BREACHED_TEXT,
  ACCEPTANCE_BREACHED_TEXT,
  LorryReceiptGenerationCategory,
  statusIdDictionary,
  indentCategory,
  epodDeleteDataReason,
  truckAssignMsg,
  chatSettingErrorMsg,
  sequenceNumberIndentStatusMap,
  languageMapping,
  materialInvoiceOtpStatus,
  materialTypes,
  eventTypes,
  findIndentByOnMaterialProces,
  inverseFreighUnit,
  indentFCMActions,
  indentFCMStatusChanges,
  tripType,
  tripStatus,
  consignmentBulkHeader,
  chainEvents,
  minTransportersCountForRFQ,
  integrationApiHistoryType,
  ptlGroupActions,
  indentDistanceUploadChunkSize,
  packageUnitTypes,
  exceptionType,
  exceptionDeviationType,
  indentSourceMapping,
  UnloadingStartEndErrorMsg,
  fcmNotificationTypes,
  sealNumberUpdatedAt,
  autoSwitchBasedOn,
  indentCreateUpdateErrors,
  materialAction,
  materialActionErrorMessage,
  lastMileEntityTypes,
  newStatus,
  statusNameDictionary,
  swimlaneGroupStatusIdDictionary,
  swimlaneGroupStatusNameDictionary,
};
